import { useMemo } from 'react'
import { usePathname } from 'next/navigation'
import { matchRouteByPath } from '@shared/utils/matchRouteByPath'

export const useCurrentRouteData = () => {
  const pathname = usePathname() ?? ''

  return useMemo(() => matchRouteByPath(pathname), [pathname])
}
